import {svgIconWrapper} from '../svg-icon-wrapper';

import ChevronLightRegularDownSvg from './chevron-light-regular-down-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <ChevronLightRegularDownSvg {...validProps} />;
}
SvgComponent.iconName = 'chevronLightRegularDown';

export const ChevronLightRegularDown = svgIconWrapper(SvgComponent);
